"use strict";
var logo = document.querySelector(".logo");
var createMessage = function createMessage(className, text) {
    var tag = document.createElement("div");
    tag.className = className;
    tag.innerHTML = text;
    document.body.appendChild(tag);
};
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve("Promise was resolved!");
    });
});
promise1.then(function() {
    createMessage("message", "Promise was resolved!");
}).catch(function() {
    createMessage("message error-message", "Promise was rejected!");
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise2.then(function() {
    createMessage("message", "Promise was resolved!");
}).catch(function() {
    createMessage("message error-message", "Promise was rejected!");
});

//# sourceMappingURL=index.df632f0e.js.map
